class programtypeTermSelection {
	constructor() {
		acf.addAction( 'load', () => {
			// Store information about our different select fields for use later.
			acf.set( 'programSelectFields', {
				type: 'field_639c78484c27d',
				program: 'field_639c78924c27e',
				orientation: 'field_639c78a44c27f',
			} );
			// Trigger our logic application
			this.applyProgramSelectionLogic();
		} );
	}

	/**
	 * Applies the logic to our ACF taxonomy fields.
	 */
	applyProgramSelectionLogic = () => {
		// Hook into select2 preparation of AJAX data.
		acf.add_filter( 'select2_ajax_data', ( data, args, $input, field, instance ) => { // eslint-disable-line no-unused-vars
			instance.on( 'change', instance.$el, function() {
				const selectFields = acf.get( 'programSelectFields' );
				// Reset the child dropdown if the program is changed.
				if ( instance.data.field.data.key === selectFields.program ) {
					const orientationField = acf.getField( selectFields.orientation );
					orientationField.$el.find( 'select' ).val( '' ).change();
				}

				// Reset the child dropdowns if the program type is changed.
				if ( instance.data.field.data.key === selectFields.type ) {
					const orientationField = acf.getField( selectFields.orientation );
					const programField = acf.getField( selectFields.program );
					programField.$el.find( 'select' ).val( '' ).change();
					orientationField.$el.find( 'select' ).val( '' ).change();
				}
			} );

			return this.addParentTermToSelect2Data( data, args, $input, field, instance );
		} );
	};

	/**
	 * Adds the parent term select fields data to the data sent through the select2 AJAX request.
	 *
	 * @param {Object} data     The data sent to the backend
	 * @param {Array}  args     arguments for the field
	 * @param {Object} $input   the DOM input
	 * @param {Object} field    Field object
	 * @param {Object} instance Instance
	 */
	addParentTermToSelect2Data = ( data, args, $input, field, instance ) => { // eslint-disable-line no-unused-vars
		const selectFields = acf.get( 'programSelectFields' );

		// Send the term id of the previous selection of "type" with the parameters for the "program" select.
		if ( args.field.data.key === selectFields.program ) {
			const parentSelect = acf.getField( selectFields.type );
			data.parentTerm = parentSelect.val();
		}

		// Send the term id of the previous selection of "program" with the parameters for the "orientation" select.
		if ( args.field.data.key === selectFields.orientation ) {
			const parentSelect = acf.getField( selectFields.program );
			data.parentTerm = parentSelect.val();
		}
		return data;
	};
}

export default programtypeTermSelection;
